import { RootState } from '../../../../stories/store';

import { YourFinanceData, YourFinanceSubmit } from './yourFinanceTypes';

export const selectYourFinance = (state: RootState): YourFinanceData => (
    state.yourFinance.data
);

export const selectYourFinanceSubmit = (state: RootState): YourFinanceSubmit => (
    state.yourFinance.submitData
);

export const selectYourFinanceSubmitUrl = (state: RootState): string|undefined => (
    state.yourFinance.submitUrl
);

export const selectYourFinanceSubmitDataReady = (state: RootState): boolean => (
    state.yourFinance.isSubmitDataReady
);

export const selectProductType = (
    (state: RootState): string => state.yourFinance.submitData.productType
);
